// extracted by mini-css-extract-plugin
module.exports = {"success":"success__Qek2h","icon":"icon__-XUgA","h3":"h3__c9M0q","p":"p__ZsS-2"};